import { PlatformQuery } from "@shared/models/platform-query/platform-query";
import { MagicLinkModel } from "@shared/models/platform-tool-models";

export class SpreadsheetQueryFactory {
  static fetchStepsQuery(platformLink: MagicLinkModel) {
    let platformQuery = new PlatformQuery();
    platformQuery.name = "GetScenarioChecklistQuery";
    platformQuery.api = "SpreadsheetApi";
    if (platformLink) {
      platformQuery.fieldValues["ScenarioId"] = "ScenarioId" in platformLink.fieldValues ? platformLink.fieldValues["ScenarioId"] : "";
      platformQuery.fieldValues["ScenarioType"] = "ScenarioType" in platformLink.fieldValues ? platformLink.fieldValues["ScenarioType"] : "";
      platformQuery.fieldValues["CountryCode"] = "CountryCode" in platformLink.fieldValues ? platformLink.fieldValues["CountryCode"] : "";
      platformQuery.fieldValues["ScenarioCalculationId"] = "ScenarioCalculationId" in platformLink.fieldValues ? platformLink.fieldValues["ScenarioCalculationId"] : "";
      platformQuery.fieldValues["WorkbookSetId"] = platformLink.fieldValues["WorkbookSetId"];
      platformQuery.fieldValues["ReportingEntityCode"] = platformLink.fieldValues["ReportingEntityCode"];
    }
    platformQuery.fieldValues["ProvideReadonlyIfNeeded"] = true;
    return platformQuery;
  }
  static fetchAbbreviationsQuery() {
    let platformQuery = new PlatformQuery();
    platformQuery.name = "GetAbbreviationsQuery";
    platformQuery.api = "SpreadsheetApi";
    platformQuery.fieldValues["ScenarioType"] = "GMT";
    platformQuery.fieldValues["ProvideReadonlyIfNeeded"] = true;
    return platformQuery;
  }

  // Lightweight worksheet list for the Overwrite Review (names + counts only).
  static fetchOverwriteWorksheetsQuery(workbookSetId: string) {
    let platformQuery = new PlatformQuery();
    platformQuery.name = "OverwriteReviewWorksheetsQuery";
    platformQuery.api = "SpreadsheetApi";
    platformQuery.fieldValues["WorkbookSetId"] = workbookSetId;
    return platformQuery;
  }

  // One worksheet's overrides, fetched lazily when that worksheet is expanded.
  static fetchOverwriteWorksheetCellsQuery(workbookSetId: string, worksheetId: string) {
    let platformQuery = new PlatformQuery();
    platformQuery.name = "OverwriteReviewWorksheetCellsQuery";
    platformQuery.api = "SpreadsheetApi";
    platformQuery.fieldValues["WorkbookSetId"] = workbookSetId;
    platformQuery.fieldValues["WorksheetId"] = worksheetId;
    return platformQuery;
  }
}
